/** @format */
import {
    Skeleton,
    SkeletonVariant,
} from '@mpb-com/feather/components/atoms/skeleton';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { SKELETON_DEFAULT_TEST_ID } from '@toucan/components/views/product/components/product-add-to-quote-link/constants';

import { StyledProductAddToQuoteLinkWrapper } from './index';

const StyledProductAddToQuoteLinkSkeleton = styled.div`
    min-width: 20rem;
`;

export const ProductAddToQuoteLinkSkeleton: FunctionComponent = () => (
    <StyledProductAddToQuoteLinkWrapper>
        <StyledProductAddToQuoteLinkSkeleton
            data-testid={SKELETON_DEFAULT_TEST_ID}
        >
            <Skeleton variant={SkeletonVariant.TEXT} width="100%" />
        </StyledProductAddToQuoteLinkSkeleton>
    </StyledProductAddToQuoteLinkWrapper>
);
